<template>
  <div class="article-wrap">
    <template v-for="(favorite, index) in favorites">
      <section class="article" :key="index">
        <div v-if="isTweet(favorite.url)">
          <Twitter v-bind:url="favorite.url"/>
        </div>
        <div v-else-if="isYouTube(favorite.url)">
          <YouTube v-bind:url="favorite.url" v-bind:title="favorite.title"/>
        </div>
        <div v-else>
          <OGPContent v-bind:url="favorite.url"/>
        </div>
        <a class="reference" v-bind:href="favorite.url">{{favorite.url}}</a>
      </section>
    </template>
  </div>
</template>

<script>
import OGPContent from './OGPContent'
import YouTube from './YouTube'
import Twitter from './Twitter'

export default {
  props: ['favorites'],
  components: {
    OGPContent,
    YouTube,
    Twitter
  },
  methods: {
    isTweet (url) {
      return url.includes('twitter.com')
    },
    isYouTube (url) {
      return url.includes('youtube.com') || url.includes('youtu.be')
    }
  }
}
</script>

<style scope>

h3 {
  color: #000;
}

a {
  font-size: 0.8rem;
}

.article-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
}

.article {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  width: 250px;
  border: 4px solid #000;
  background-color: #fff;
  margin: 1em;
  padding: 1em;
}

.reference {
  font-size: 0.6rem;
  color: #7F8EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/FavoriteList.vue